import React, { Component } from 'react'
import { Tenant } from 'models/Blip/Index'
import { SearchTable } from 'components/SearchTable'
import { Icon, Card, Table, notification } from 'antd'
import { getMembers } from 'services/CeberusApiService'
import { TenantService } from 'connection/TenantService'
import { SearchOrganizationRequest } from 'models/request/Index'
import { SearchOrganizationResponse, TenantUserInformationResponse } from 'models/response/Index'
import { PushNotification } from 'utils/PushNotification'

const { Column } = Table;
const TENANT_USERS_PAGE_SIZE = 100;

const handleSearch = (selectedKeys: string, confirm: Function) => () => {
  confirm();
}
  
const handleReset = (clearFilters: Function) => () => {
  clearFilters();
}

export class OrganizationMembers extends Component<SearchOrganizationResponse> {
  state = {
    isLoading: false,
    isModalLoading: false,
    isModalVisible: false,
    tenantSelected: new Tenant(),
    members: new Array<TenantUserInformationResponse>()
  }

  openErrorToast = () => {
    notification.error({
      message: 'Tenant not found!',
      description: 'Please insert a valid id and try again',
      placement: 'bottomLeft',
    })
  }

  async componentDidMount() {
    this.loadPage();
  }

  loadPage = async () : Promise<void> => {
    const tenantSelected = TenantService.getSelectedTenant();
    this.setState({ tenantSelected, isLoading: true });
    
    if (!this.props.Id) {
      return
    }

    let page = 0;
    let members = [];
    let membersLength = 0;

    do {
      try {
        const request = new SearchOrganizationRequest();
        request.Page = page;
        request.OrganizationId = this.props.Id;
        request.ClusterName = tenantSelected.name;
        const response = await getMembers(request);

        membersLength = response.length;
        members = [...members, ...response];
        page++
      } catch (error) {
        PushNotification.httpError(error);
        break;
      }
    } while (membersLength === TENANT_USERS_PAGE_SIZE)

    members.length > 0 && this.setState({ members });
    this.setState({ isLoading: false });
  }

  render() {
    const cardTitle = `Total of members on ${this.props.Name}: ${this.state.members.length}`;

    let searchInput;

    return (
      <div className="mt5 w-100">
        <Card title={cardTitle} className="mb3" loading={this.state.isLoading}>
          <Table dataSource={this.state.members}>
            <Column 
              key='fullName' 
              title='Email' 
              dataIndex='fullName'
              width='50%' 
              sorter={(a: TenantUserInformationResponse, b: TenantUserInformationResponse) => a.fullName.localeCompare(b.fullName)} 
              onFilter={(value, record: TenantUserInformationResponse) => record.fullName.toString().includes(value.toString())}
              filterIcon={(filtered) => <Icon type="search" style={{ color: filtered ? '#108ee9' : '#aaa' }} />}
              onFilterDropdownVisibleChange={(visible) => visible && setTimeout(() => searchInput.focus())}
              filterDropdown={({
                setSelectedKeys, selectedKeys, confirm, clearFilters,
              }) => (
                <SearchTable
                  onSetRef={e => (searchInput = e)}
                  onSetSelectedKeys={setSelectedKeys}
                  selectedKeys={selectedKeys}
                  confirm={confirm}
                  clearFilters={clearFilters}
                  onSearch={handleSearch}
                  onReset={handleReset}
                />
              )}/>
            <Column 
              key='userStatus' 
              title='Status' 
              dataIndex='userStatus' 
              width='25%' 
              sorter={(a: TenantUserInformationResponse, b: TenantUserInformationResponse) => a.userIdentity.localeCompare(b.userIdentity)} 
              onFilter={(value, record: TenantUserInformationResponse) => record.userIdentity.toString().includes(value.toString())}
              filters={[
                { text: 'Accepted', value: 'Accepted' },
                { text: 'PendingUser', value: 'PendingUser' },
                { text: 'Rejected', value: 'Rejected' },
                { text: 'PendingTenant', value: 'PendingTenant' },
              ]}/>
            <Column 
              key='roleId' 
              title='Role' 
              dataIndex='roleId' 
              width='25%' 
              sorter={(a: TenantUserInformationResponse, b: TenantUserInformationResponse) => a.roleId.toString().localeCompare(b.roleId.toString())} 
              onFilter={(value, record: TenantUserInformationResponse) => record.roleId.toString().includes(value.toString())}
              filters={[
                { text: 'Admin', value: 'admin' },
                { text: 'Member', value: 'member' },
                { text: 'Guest', value: 'guest' },
              ]}/>
          </Table>
        </Card>
      </div>
    )
  }
}
